import styled from 'styled-components/macro';
import { COLORS } from 'utils/styles/colors';
import { deviceMax } from 'utils/styles/breakpoints';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const RequestsFullWrapper = styled.div`
  ${FLEX_CONTAINER.FlexColumn}
  width: 1200px;
  backdrop-filter: blur(20px);
  border-radius: 12px;
  background: linear-gradient(
    155.67deg,
    rgba(255, 255, 255, 0.59) -7.08%,
    rgba(255, 255, 255, 0.13) 110.41%
  );
  box-shadow: 0 4px 24px -1px ${COLORS.mainColor};

  @media only screen and ${deviceMax.laptopL} {
    width: 688px;
  }

  @media only screen and ${deviceMax.tablet} {
    width: 426px;
    padding-bottom: 50px;
  }

  @media only screen and ${deviceMax.mobileL} {
    width: 302px;
  }
`;

export const FullInsideContainer = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenColumn}
  width: 100%;
  height: auto;
  margin-top: 20px;
  padding-left: ${({ Offers }) => (Offers ? '40px' : '0')};
  padding-right: ${({ Offers }) => (Offers ? '40px' : '0')};

  @media only screen and ${deviceMax.mobileL} {
    ${FLEX_CONTAINER.Unset}
  }
`;

export const TopContainer = styled.div`
  ${FLEX_CONTAINER.FlexRow};
  gap: 20px;
  width: 100%;
  padding-left: ${({ startPage }) => (startPage ? '20px' : '48px')};
  height: 50px;

  @media only screen and ${deviceMax.mobileL} {
    padding-left: 20px;
  }
`;

export const BackToPreviousPageIcon = styled.img`
  cursor: pointer;
`;

export const RequestsText = styled.span`
  ${FONT_FAMILY.FontBold}
  ${FONTS.font20}
  ${FLEX_CONTAINER.FlexRow}
  color: ${COLORS.mainColor};
`;

export const RequestsWrapper = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow};
  flex-wrap: wrap;
  width: 100%;
  padding: 10px 40px;

  @media only screen and ${deviceMax.laptopLMax} {
    ${FLEX_CONTAINER.FlexCenterRow};
  }

  @media only screen and ${deviceMax.tablet} {
    ${FLEX_CONTAINER.FlexCenterColumn};
    padding: 10px 22px;
  }

  @media only screen and ${deviceMax.mobileL} {
    padding-right: 10px;
    padding-left: 10px;
  }
`;

export const RightBlockOfRequests = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow};

  @media only screen and (max-width: 768px) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;
